
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

import { OrganisationModel } from 'src/models/pilotage/organisationModel';
import { ParametreEntiteService } from 'src/services/parametre-entite.service';

@Component({
    selector: 'app-edit-parametre-entite-dialog',
    templateUrl: './edit-parametre-entite-dialog.component.html',
    styleUrls: ['./edit-parametre-entite-dialog.component.scss'],
    imports: [
    MatProgressSpinnerModule,
    TranslateModule,
    MatIconModule,
    FormsModule,
    FormsModule
]
})
export class EditParametreEntiteDialogComponent implements OnInit {
organisation!: OrganisationModel;
  isLoading = true;
  isSaving = false;
  estRaisonSocialeAffiche!: boolean;

  constructor(
    private dialogRef: MatDialogRef<EditParametreEntiteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrganisationModel,
    private parametreEntiteService: ParametreEntiteService
  ) {}

  ngOnInit(): void {
      this.organisation = this.data;
      this.estRaisonSocialeAffiche = this.organisation.estRaisonSocialeAffiche;
      this.isLoading = false;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onChange(): void {
    if (!this.organisation) return;
       this.organisation.estRaisonSocialeAffiche = this.estRaisonSocialeAffiche;
    if (this.estRaisonSocialeAffiche) {
        this.organisation.nom = this.organisation.raisonSociale;
    } else {
        this.organisation.nom = this.organisation.nomLegal;
    }
  }


  onSave(): void {
   this.isSaving = true;
    this.parametreEntiteService.MiseAJourNom(this.organisation)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.dialogRef.close(true);
        },
        error: () => {
          this.isSaving = false;
        }
      });
  }
}
